module.exports = __webpack_public_path__ + "img/ula_logo.61ec3934.png";